import script from "./ListarProtocolosQueda.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarProtocolosQueda.vue?vue&type=script&setup=true&lang=js"

import "./ListarProtocolosQueda.vue?vue&type=style&index=0&id=afddf3a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afddf3a8"]])

export default __exports__